import $ from 'jquery';

/**
 * Just calls a function.
 * @param {function} func
 */
const runCode = (func) => {
    func(); // set a breakpoint on this line to debug onload code
};

/**
 * Runs some when on window load.
 * @param {function} func
 */
export function onLoad(func) {
    $(window).on('load', () => runCode(func));
}

/**
 * Runs some code when DOM is ready.
 * @param {function} func
 */
export function onDOMReady(func) {
    $(() => runCode(func));
}
